import { CardProps } from '@material-ui/core';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import BusinessIcon from '@material-ui/icons/Business';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import HomeWorkOutlinedIcon from '@material-ui/icons/HomeWorkOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { PeppolRecordStatusChip } from 'app/main/integrations/peppol/peppol.components';
import { calcPatientDetailRoute } from 'app/main/patients/calcPatientDetailRoute';
import { calcRequestForInsuranceAllowanceDetailRoute } from 'app/main/processes/ProcessesRoutes';
import { CardX } from 'framework/components/cards/CardX';
import { StatusIcon } from 'framework/components/icons/StatusIcon';
import { CaptionVerticalLabelledPropertyX } from 'framework/components/labelledProperty/CaptionVerticalLabelledPropertyX';
import { LabelledPropertyX } from 'framework/components/labelledProperty/LabelledPropertyX';
import { Typography16pxBold } from 'framework/components/typography/Typography16pxBold';
import { formatCurrency } from 'framework/utils/formatCurrency';
import { ISalesDto } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { calcCustomerAccountDetailRoute } from '../../routes';
import { PeppolRoute } from 'app/main/integrations/IntegrationsRoutes';

const Width: number = 280;

interface IProps extends CardProps {
	item: ISalesDto;
	reload: VoidFunction;
}

export const SalesDetailOverviewHeaderCard = ({ item, reload, ...rest }: IProps) => {
	const strings = useLocalization();
	const { push } = useHistory();

	return (
		<CardX
			{...rest}
			className='df-row-wrap gap-16'>
			<div
				className='df-col gap-6'
				style={{ width: Width }}>
				<Typography16pxBold>{strings.paymentDetails}</Typography16pxBold>
				<CaptionVerticalLabelledPropertyX label={strings.amountToPay}>{formatCurrency(item.data.amountToPay)}</CaptionVerticalLabelledPropertyX>
				<CaptionVerticalLabelledPropertyX label={strings.amountPaid}>{formatCurrency(item.data.amountPaid)}</CaptionVerticalLabelledPropertyX>
				<CaptionVerticalLabelledPropertyX label={strings.outstandingBalance}>{formatCurrency(item.data.outstandingBalance)}</CaptionVerticalLabelledPropertyX>
				<CaptionVerticalLabelledPropertyX label={strings.structuredReference}>
					{item.data.defaultBelgianStructuredCreditorReference}
				</CaptionVerticalLabelledPropertyX>
			</div>
			{Boolean(item.data.recipient) && (
				<div
					className='df-col gap-6'
					style={{ width: Width }}>
					<Typography16pxBold>{strings.recipient}</Typography16pxBold>
					<LabelledPropertyX icon={<PersonOutlineIcon />}>{item.data.recipient.name}</LabelledPropertyX>
					{item.data.recipient.hasVatNumber && <LabelledPropertyX icon={<BusinessIcon />}>{item.data.recipient.vatNumber}</LabelledPropertyX>}
					{item.data.recipient.hasData && (
						<LabelledPropertyX icon={<HomeWorkOutlinedIcon />}>
							<span style={{ whiteSpace: 'pre' }}>{item.data.recipient.formattedAddressMultipleLines}</span>
						</LabelledPropertyX>
					)}
				</div>
			)}
			<div className='df-col gap-6'>
				<Typography16pxBold>{strings.links}</Typography16pxBold>
				{item.data.referencePatient && (
					<LabelledPropertyX
						icon={<PersonOutlineIcon />}
						link={() => push(calcPatientDetailRoute(item.data.referencePatient.id!))}>
						{strings.patient}
					</LabelledPropertyX>
				)}
				{item.data.cashSaleForPatient && (
					<LabelledPropertyX
						icon={<PersonOutlineIcon />}
						link={() => push(calcPatientDetailRoute(item.data.cashSaleForPatient.id!))}>
						{item.data.cashSaleForPatient.identifier}
					</LabelledPropertyX>
				)}
				{item.data.singleCustomerAccount && (
					<LabelledPropertyX
						icon={<AccountBalanceWalletOutlinedIcon />}
						link={() => push(calcCustomerAccountDetailRoute(item.data.singleCustomerAccount.customerAccountId!))}>
						{strings.accountReceivable}
					</LabelledPropertyX>
				)}
				{item.data.rfiaId && (
					<LabelledPropertyX
						icon={<DoubleArrowIcon />}
						link={() => push(calcRequestForInsuranceAllowanceDetailRoute(item.data.rfiaId!))}>
						{strings.requestForInsuranceAllowanceShort}
					</LabelledPropertyX>
				)}
				<Typography16pxBold>{`Peppol`}</Typography16pxBold>
				<CaptionVerticalLabelledPropertyX
					label={`Peppol integratie?`}
					startIcon={<StatusIcon status={item.canSendOnPeppolNetwork ? 'success' : 'error'} />}>
					{item.canSendOnPeppolNetwork ? strings.counterPartyIsVatCustomerWithValidVatNumber : strings.counterPartyIsNotAVatCustomerOrNoValidVatNumber}
				</CaptionVerticalLabelledPropertyX>
				{item.canSendOnPeppolNetwork && (
					<CaptionVerticalLabelledPropertyX
						label={`Peppol status?`}
						startIcon={<StatusIcon status={item.peppolRecord!.status === 'Sent' ? 'success' : 'error'} />}
						edit={() => push(PeppolRoute)}>
						<PeppolRecordStatusChip status={item.peppolRecord!.status} />
					</CaptionVerticalLabelledPropertyX>
				)}
			</div>
		</CardX>
	);
};
